export const CENTENARIO_CURRENCY_CODE = 'CEN';

export function isCentenarioCurrencyCode(
  code: string | null | undefined,
): boolean {
  return (
    String(code ?? '')
      .trim()
      .toUpperCase() === CENTENARIO_CURRENCY_CODE
  );
}

/** Whole units 1–10 for display (aligned with quoter centenario limits). */
export function formatCentenarioUnitsDisplay(
  amount: number | null | undefined,
): string {
  const n = Number(amount) || 0;
  if (n <= 0) {
    return '0';
  }
  const unit = Math.min(10, Math.max(1, Math.round(n)));
  return String(unit);
}
